import {
  REQUEST_EPARK_LOGIN_USER_DATA, RECEIVE_EPARK_LOGIN_USER_DATA, INVALIDATE_EPARK_LOGIN_USER_DATA
} from '../../actions/MemberAction';

// const convertData = data => {
//   const newData = data.reduce(function(acc, obj) {

//     //epark user
//     if(obj.user_type === 'epark_user'){
//       acc[obj.yymm] = {
//         ...acc[obj.yymm],
//         yymm: obj.yymm,
//         epark_user: obj.cnt
//       }
//     }else{
//       acc[obj.yymm] = {
//         ...acc[obj.yymm],
//         yymm: obj.yymm,
//         all_user: obj.cnt
//       }
//     }

//     if(!acc[obj.yymm].epark_user)
//       acc[obj.yymm].epark_user = 0;

//     if(!acc[obj.yymm].all_user)
//       acc[obj.yymm].all_user = 0;

//     return acc;
//   }, {});

//   var arrData = Object.keys(newData).map(function (key) { return newData[key]; });

//   return arrData;
// }

const convertData = data => {

  data.sort((a,b) => a.yymm - b.yymm);

  for(let i=0; i < data.length; i += 1 ){
    if(i === 0) data[0].sum = data[0].count;
    else data[i].sum = data[i].count + data[i-1].sum;
  }

  const resultArray = data.map((data, index) => {
        var rObj = {};
        rObj.yymm = data.yymm.substr(0,4) + '-' + data.yymm.substr(4,2);
        rObj.count = data.count;
        rObj.sum = data.sum;

        return rObj;
      });
  
  return resultArray;
}


const memberUser = (state = {
  isFetching: false,
  didInvalidate: true,
  data: [],
  isActivityUser: true
}, action)=> {
  switch(action.type){
    case INVALIDATE_EPARK_LOGIN_USER_DATA:
      return { ...state,
        didInvalidate: true
      }
    case REQUEST_EPARK_LOGIN_USER_DATA:
      return { ...state,
              isFetching: true,
              didInvalidate: false
            }
    case RECEIVE_EPARK_LOGIN_USER_DATA:
      return { ...state,
        isFetching: false,
        didInvalidate: false,
        data: convertData(action.data),
        isActivityUser: action.isActivityUser,
        lastUpdated: action.receivedAt
      }
    default:
      return state;
  }
}

export default memberUser;


// WEBPACK FOOTER //
// ./src/reducers/member/eparkLoginUser.js